import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { StorageService } from "./storage-Service";
import { HttpheadersModel } from "../models/httpHeaders";
import { HttpHeaderService } from "./http-headers";

@Injectable()
export class RequestInterptor implements HttpInterceptor {
  username = environment.appUser;
  password = environment.appPwd;
  headers = new HttpheadersModel();

  constructor(
    private storage: StorageService,
    private headerservice: HttpHeaderService,
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    let token = this.storage.getAccessToken(); //get the application access control for the app
    //check if the access control exist and if the request is to get access control

    if (req.url.includes("getToken")) {
      req = req.clone({
        setHeaders: {
          Authorization: "Basic " + btoa(this.username + ":" + this.password),
          "Content-Type": "application/json",
        },
      });
      return next.handle(req);
    } else if (req.url.includes("support")) {
      let url = req.urlWithParams.substring(req.urlWithParams.indexOf(".com"));

      url = url.substring(4);
      url = this.setBaseUrlForOtherCountries(url);

      this.setRequestHeaders(req.method, url);
      req = req.clone({
        setHeaders: {
          "Content-Type": "application/json",
          Nonce: this.headers.Nonce,
          // Timestamp: this.headers.Timestamp,
          "X-CHECKOUT-TOKEN": token,
        },
      });
      // return next.handle(req);
    } else if (
      req.url.includes("subscription") ||
      req.url.includes("instalment")
    ) {
      let url = req.url.slice(req.url.indexOf(".com"));
      url = url.substring(4);

      this.setRequestHeaders(req.method, url);
      req = req.clone({
        setHeaders: {
          "Content-Type": "application/json",
          Nonce: this.headers.Nonce ?? "",
          // Timestamp: this.headers.Timestamp,
          "X-CHECKOUT-TOKEN": token ?? "",
          deviceInformation: JSON.stringify({
            httpBrowserLanguage: this.headers.httpBrowserLanguage.toString(),
            httpBrowserJavaEnabled: this.headers.httpBrowserJavaEnabled,
            httpBrowserJavaScriptEnabled:
              this.headers.httpBrowserJavaScriptEnabled,
            httpBrowserColorDepth: this.headers.httpBrowserColorDepth,
            httpBrowserScreenHeight: this.headers.httpBrowserScreenHeight,
            httpBrowserScreenWidth: this.headers.httpBrowserScreenWidth,
            httpBrowserTimeDifference: this.headers.httpBrowserTimeDifference,
            userAgentBrowserValue: this.headers.userAgentBrowserValue,
            httpBrowserTZ: this.headers.httpBrowserTZ,
            httpBrowserAcceptHeader: this.headers.httpBrowserAcceptHeader,
          }),
        },
      });
      return next.handle(req);
    } else if (req.url.includes("invoice")) {
      let url = req.url.slice(req.url.indexOf(".com"));

      url = url.substring(4);

      this.setRequestHeaders(req.method, url);
      req = req.clone({
        setHeaders: {
          "Content-Type": "application/json",
          Nonce: this.headers.Nonce,
          "X-CHECKOUT-TOKEN": token ?? "",
        },
      });
      return next.handle(req);
    } else if (req.url.includes("getPaymentPageDetails")) {
      let url = req.urlWithParams.substring(
        req.urlWithParams.indexOf(".com") + 4,
      );

      // url = url.substring(4);
      // url = this.setBaseUrlForOtherCountries(url);

      this.setRequestHeaders(req.method, url);

      req = req.clone({
        setHeaders: {
          "Content-Type": "application/json",
          Nonce: this.headers.Nonce,
          // Timestamp: this.headers.Timestamp,
          Rexpay_checkout: this.headers.Rexpay_checkout,

          deviceInformation: JSON.stringify({
            httpBrowserLanguage: this.headers.httpBrowserLanguage.toString(),
            httpBrowserJavaEnabled: this.headers.httpBrowserJavaEnabled,
            httpBrowserJavaScriptEnabled:
              this.headers.httpBrowserJavaScriptEnabled,
            httpBrowserColorDepth: this.headers.httpBrowserColorDepth,
            httpBrowserScreenHeight: this.headers.httpBrowserScreenHeight,
            httpBrowserScreenWidth: this.headers.httpBrowserScreenWidth,
            httpBrowserTimeDifference: this.headers.httpBrowserTimeDifference,
            userAgentBrowserValue: this.headers.userAgentBrowserValue,
            httpBrowserTZ: this.headers.httpBrowserTZ,
            httpBrowserAcceptHeader: this.headers.httpBrowserAcceptHeader,
          }),
        },
      });
    } else {
      let url = req.urlWithParams.substring(
        req.urlWithParams.indexOf(".com") + 4,
      );

      // url = url.substring(4);
      // url = this.setBaseUrlForOtherCountries(url);

      this.setRequestHeaders(req.method, url);

      req = req.clone({
        setHeaders: {
          "Content-Type": "application/json",
          Nonce: this.headers.Nonce,
          // Timestamp: this.headers.Timestamp,
          "X-CHECKOUT-TOKEN": token ?? "",
          Rexpay_checkout: this.headers.Rexpay_checkout,

          deviceInformation: JSON.stringify({
            httpBrowserLanguage: this.headers.httpBrowserLanguage.toString(),
            httpBrowserJavaEnabled: this.headers.httpBrowserJavaEnabled,
            httpBrowserJavaScriptEnabled:
              this.headers.httpBrowserJavaScriptEnabled,
            httpBrowserColorDepth: this.headers.httpBrowserColorDepth,
            httpBrowserScreenHeight: this.headers.httpBrowserScreenHeight,
            httpBrowserScreenWidth: this.headers.httpBrowserScreenWidth,
            httpBrowserTimeDifference: this.headers.httpBrowserTimeDifference,
            userAgentBrowserValue: this.headers.userAgentBrowserValue,
            httpBrowserTZ: this.headers.httpBrowserTZ,
            httpBrowserAcceptHeader: this.headers.httpBrowserAcceptHeader,
          }),
        },
      });
    }

    return next.handle(req);
  }

  setRequestHeaders(meth: string, url: string) {
    // this.headers.signature = this.headerservice.setSignature(meth, url);
    this.headerservice.setHeaders();
    this.headers.Nonce = this.headerservice.httpheaders.Nonce;
    // this.headers.Timestamp = this.headerservice.httpheaders.Timestamp;
    this.headers.X_TOKEN = this.headerservice.httpheaders.accessToken;
    // this.headers.X_SECRET = this.headerservice.httpheaders.accessKey;
    this.headers.Rexpay_checkout =
      this.headerservice.httpheaders.Rexpay_checkout;
    this.headers.httpBrowserLanguage =
      this.headerservice.httpheaders.httpBrowserLanguage;
    this.headers.httpBrowserJavaEnabled =
      this.headerservice.httpheaders.httpBrowserJavaEnabled;
    this.headers.httpBrowserJavaScriptEnabled =
      this.headerservice.httpheaders.httpBrowserJavaScriptEnabled;
    this.headers.httpBrowserColorDepth =
      this.headerservice.httpheaders.httpBrowserColorDepth;
    this.headers.httpBrowserScreenHeight =
      this.headerservice.httpheaders.httpBrowserScreenHeight;
    this.headers.httpBrowserScreenWidth =
      this.headerservice.httpheaders.httpBrowserScreenWidth;
    this.headers.httpBrowserTimeDifference =
      this.headerservice.httpheaders.httpBrowserTimeDifference;
    this.headers.userAgentBrowserValue =
      this.headerservice.httpheaders.userAgentBrowserValue;
    this.headers.httpBrowserTZ = this.headerservice.httpheaders.httpBrowserTZ;
    this.headers.httpBrowserAcceptHeader =
      this.headerservice.httpheaders.httpBrowserAcceptHeader;
    this.headers.deviceInformation = {
      httpBrowserLanguage: this.headers.httpBrowserLanguage,
      httpBrowserJavaEnabled: this.headers.httpBrowserJavaEnabled.toString(),
      httpBrowserJavaScriptEnabled: this.headers.httpBrowserJavaScriptEnabled,
      httpBrowserColorDepth: this.headers.httpBrowserColorDepth,
      httpBrowserScreenHeight: this.headers.httpBrowserScreenHeight,
      httpBrowserScreenWidth: this.headers.httpBrowserScreenWidth,
      httpBrowserTimeDifference: this.headers.httpBrowserTimeDifference,
      userAgentBrowserValue: this.headers.userAgentBrowserValue,
      httpBrowserTZ: this.headers.httpBrowserTZ,
      httpBrowserAcceptHeader: this.headers.httpBrowserAcceptHeader,
    };
  }

  setBaseUrlForOtherCountries(url) {
    if (url.includes(".gh")) {
      return url.substring(3);
    }
    return url;
  }
}
